import React from 'react';
import { Col, Flex, Row } from 'antd';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import CountBadge from '@totem/components/vendors/CountBadge';
import MergeButton from '@totem/components/vendors/MergeButton';
import VendorContainer from '@totem/components/vendors/VendorContainer';
import VendorFilters from '@totem/components/vendors/VendorFilters';
import VendorTable from '@totem/components/vendors/VendorTable';

const VendorsPage = () => {
  return (
    <ContentLayout>
      <VendorContainer>
        <IBCard isCovered>
          <VendorFilters />
          <br />
          <Row>
            <Col span={12}>
              <Flex justify={'flex-start'} align={'center'}>
                <MergeButton isPrimary />
              </Flex>
            </Col>
            <Col span={12}>
              <Flex justify={'flex-end'} align={'center'}>
                <CountBadge />
              </Flex>
            </Col>
          </Row>
          <br />
          <VendorTable />
        </IBCard>
      </VendorContainer>
    </ContentLayout>
  );
};

export default VendorsPage;
